import { type UsePreFilteredExtensionsQueryOptions } from '@atlassian/forge-ui/provider';

import { getAGGClient } from '@confluence/graphql/entry-points/getAGGClient';

export const getUsePrefilteredExtensionListOptions = ({
	cloudId,
	locale,
	moduleType,
	queryOptions,
	includeHidden,
	spaceKey,
	contentId,
}) => {
	const options: UsePreFilteredExtensionsQueryOptions = {
		client: getAGGClient(),
		cloudId,
		types: [moduleType],
		queryOptions: {
			...queryOptions,
		},
		locale,
		context: { spaceKey, contentId },
		includeHidden,
	};

	return options;
};
